<template>
  <slot name="button" v-bind="{ toggle, label }">
    <SelectModalSharedButton
      :label="label"
      :description="selectedText"
      @toggle="toggle"
      :loading="loading"
    />
  </slot>
  <NamiModal v-model="showModal">
    <NamiModalTitle @close="toggle" subtitle="Select one">
      {{ label }}
    </NamiModalTitle>
    <SelectModalContentSingle
      :model-value="props.modelValue"
      :options="options"
      @update:model-value="(v) => ($emit('update:modelValue', v), toggle())"
    />
    <NamiButton
      button-type="secondary"
      block
      @button-click="toggle"
      small
      class="mt-4"
    >
      Done
    </NamiButton>
  </NamiModal>
</template>

<script setup lang="ts" generic="T">
import type { Props as ContentProps } from "./content/Single.vue";

export type Option<T> = {
  text: string;
  value: T;
  description?: string;
};

export type Props<T> = ContentProps<T> & {
  label: string;
  placeholder?: string;
  loading?: boolean;
};

const props = defineProps<Props<T>>();

defineEmits<{
  (e: "update:modelValue", v: T): void;
}>();

const showModal = ref(false);

function toggle() {
  showModal.value = !showModal.value;
}

const selectedText = computed(
  () =>
    props.options.find((s) => s.value === props.modelValue)?.text ??
    props.placeholder ??
    "Nothing selected",
);

defineExpose({
  selectedText,
});
</script>
